import React from 'react';
import { Icon } from '../../assets/icons/Icon.jsx';

/** Centered modal dialog with dimmed backdrop. Render conditionally on `open`. */
export function Dialog({ open = true, title, children, primaryAction, secondaryAction, onClose, width = 360, style }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        background: 'var(--material-dimmer)',
        fontFamily: 'var(--font-sans)',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width,
          maxWidth: '100%',
          background: 'var(--background-elevated-normal)',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-overlay)',
          padding: 24,
          boxSizing: 'border-box',
          ...style,
        }}
      >
        {title && (
          <div style={{ fontSize: 'var(--font-size-heading-2)', lineHeight: 'var(--line-height-heading-2)', fontWeight: 700, color: 'var(--label-normal)', marginBottom: 8 }}>{title}</div>
        )}
        {children && (
          <div style={{ fontSize: 'var(--font-size-body-2)', lineHeight: 'var(--line-height-body-2-reading)', color: 'var(--label-alternative)' }}>{children}</div>
        )}
        {(primaryAction || secondaryAction) && (
          <div style={{ display: 'flex', gap: 8, marginTop: 24 }}>
            {secondaryAction}
            {primaryAction}
          </div>
        )}
      </div>
    </div>
  );
}

export default Dialog;
